import axios from "axios";
import { ISignInRequest } from "app/api/types/Auth";

export default (data: ISignInRequest) =>
  axios.post(`${process.env.REACT_APP_API_HOST}/auth/signin`, data);
